module.exports = __webpack_public_path__ + "img/tc_2.5e73113f.png";